import type { HTMLAttributes } from 'react'
import cx from 'classnames'
import styles from './ActionToggle.module.css'
import { SwitchCheckbox } from '@/components/SwitchCheckbox'

interface ActionToggleProps extends HTMLAttributes<HTMLDivElement> {
  label: string
  description: string
  value: boolean
  onChange(e: unknown): void
  isThemed?: boolean
  isDisabled?: boolean
  testId?: string
}

/**
 * A labelled switch with a description.
 */
export function ActionToggle({
  label,
  description,
  value,
  onChange,
  className,
  isThemed,
  testId,
  isDisabled,
  ...rest
}: ActionToggleProps) {
  return (
    <div className={cx(styles.container, className)} {...rest}>
      <div className={styles.information}>
        <div className={styles.label}>{label}</div>
        <div className={styles.description}>{description}</div>
      </div>
      <SwitchCheckbox
        noText
        value={value}
        onChange={onChange}
        success={isThemed}
        isDisabled={isDisabled}
        testId={testId}
      />
    </div>
  )
}
